module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || '5wzjkpee',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
